import request from 'graphql-request';
import { fromPromise } from 'xstate';

import { FlowEntity } from '../../types';

import { updateEmailCacheKey, updateEmailMutation } from './graphql/constants';

export type UpdateEmailInput = {
    email: string;
    confirmEmail: string;
    token: string;
};

export const updateEmailActor: FlowEntity = {
    initActor: ({ queryClient }) =>
        fromPromise<
            { success: boolean; message?: string | null; errors?: string | null },
            UpdateEmailInput
        >(async ({ input }) => {
            const res = await queryClient.fetchQuery({
                queryKey: [updateEmailCacheKey, input],
                queryFn: () => {
                    const requestHeaders = {
                        'request-source': updateEmailCacheKey,
                    };

                    return request(
                        `/api/tn/app-shell/graphql/`,
                        updateEmailMutation,
                        {
                            formFields: {
                                email: input.email,
                                confirmEmail: input.confirmEmail,
                                token: input.token,
                            },
                        },
                        {
                            ...requestHeaders,
                        },
                    );
                },
                staleTime: 0,
                gcTime: 0,
            });

            if (res.updateEmail) {
                return res.updateEmail;
            }

            throw new Error('Update email mutation failed');
        }),
};
